/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * new_mail object
 * @export
 * @interface PostUiOpenwindowNewmailNewMail
 */
export interface PostUiOpenwindowNewmailNewMail {
    /**
     * body string
     * @type {string}
     * @memberof PostUiOpenwindowNewmailNewMail
     */
    body: string;
    /**
     * recipients array
     * @type {Array<number>}
     * @memberof PostUiOpenwindowNewmailNewMail
     */
    recipients: Array<number>;
    /**
     * subject string
     * @type {string}
     * @memberof PostUiOpenwindowNewmailNewMail
     */
    subject: string;
    /**
     * to_corp_or_alliance_id integer
     * @type {number}
     * @memberof PostUiOpenwindowNewmailNewMail
     */
    toCorpOrAllianceId?: number;
    /**
     * Corporations, alliances and mailing lists are all types of mailing groups. You may only send to one mailing group, at a time, so you may fill out either this field or the to_corp_or_alliance_ids field
     * @type {number}
     * @memberof PostUiOpenwindowNewmailNewMail
     */
    toMailingListId?: number;
}

/**
 * Check if a given object implements the PostUiOpenwindowNewmailNewMail interface.
 */
export function instanceOfPostUiOpenwindowNewmailNewMail(value: object): value is PostUiOpenwindowNewmailNewMail {
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function PostUiOpenwindowNewmailNewMailFromJSON(json: any): PostUiOpenwindowNewmailNewMail {
    return PostUiOpenwindowNewmailNewMailFromJSONTyped(json, false);
}

export function PostUiOpenwindowNewmailNewMailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUiOpenwindowNewmailNewMail {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
        'recipients': json['recipients'],
        'subject': json['subject'],
        'toCorpOrAllianceId': json['to_corp_or_alliance_id'] == null ? undefined : json['to_corp_or_alliance_id'],
        'toMailingListId': json['to_mailing_list_id'] == null ? undefined : json['to_mailing_list_id'],
    };
}

export function PostUiOpenwindowNewmailNewMailToJSON(json: any): PostUiOpenwindowNewmailNewMail {
    return PostUiOpenwindowNewmailNewMailToJSONTyped(json, false);
}

export function PostUiOpenwindowNewmailNewMailToJSONTyped(value?: PostUiOpenwindowNewmailNewMail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
        'recipients': value['recipients'],
        'subject': value['subject'],
        'to_corp_or_alliance_id': value['toCorpOrAllianceId'],
        'to_mailing_list_id': value['toMailingListId'],
    };
}

